export default __webpack_public_path__ + "static/media/pdf-placeholder.21d261a0.jpg";